module.exports = __webpack_public_path__ + "static/media/delivery person.2acfb44d.png";